import { makeStyles } from '@material-ui/styles';
import { colors } from '../../../style/colors';
import { ITheme } from '../../../style/theme';

interface StyleProps {
  baseWidth?: string | number;
  onClick?: any;
  disabled?: boolean;
  height?: string | number;
  type?: 'mentor' | 'offering' | 'booking';
}

const useStyles = makeStyles<ITheme, StyleProps>((theme: ITheme) => ({
  arrow: {
    marginLeft: -8,
    opacity: 0,
  },
  wrapper: {
    minHeight: ({ height }: StyleProps) => height ?? '100%',
    height: ({ height, type }: StyleProps) =>
      type === 'mentor' ? height : '100%',
    cursor: 'pointer',
    '&:hover': {
      filter: 'drop-shadow(0px 8px 24px rgba(27, 27, 28, 0.15))',
    },
    [theme.breakpoints.down(400)]: {
      height: '100%!important',
    },
  },
  hideOverlay: {
    '&:after': {
      display: 'none',
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    fontFamily: 'DM Sans',
    width: 350,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      flex: ({ baseWidth }: StyleProps) => baseWidth && `1 ${baseWidth}px`,
      width: ({ baseWidth }: StyleProps) => (baseWidth ? 'auto' : '100%'),
      minWidth: ({ type }: StyleProps) => type === 'booking' && '340px',
    },
    filter: 'drop-shadow(0px 6px 12px rgba(27, 27, 28, 0.15))',
    backgroundColor: 'transparent',
    borderRadius: 16,
    color: colors.darkestGray,
    padding: '0 24px 24px 24px',
    [theme.breakpoints.up(400)]: {
      paddingBottom: ({ type }) => (type === 'offering' ? '0px' : '24px'),
    },
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: ({ disabled }: StyleProps) => !disabled && 0,
      left: 0,
      width: '100%',
      bottom: ({ disabled }: StyleProps) => disabled && 0,
      height: ({ disabled }: StyleProps) =>
        disabled ? 'calc(100% - 44px)' : '100%',
      borderRadius: 16,
      background: ({ disabled }: StyleProps) =>
        disabled ? colors.disabledOverlay : 'transparent',
      transition: 'all .5s ease-out',
    },
  },
  cardContent: {
    position: 'relative',
    backgroundColor: colors.white,
    display: 'flex',
    flexDirection: 'column',
    minHeight: ({ type }: StyleProps) =>
      type === 'offering' ? '518px' : 'auto',
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-24px',
      width: 'calc(100% + 48px)',
      height: '100%',
      background: colors.white,
      zIndex: -1,
      borderRadius: '0 0 16px 16px',
    },
    paddingBottom: ({ type }) => (type === 'mentor' ? 0 : 24),
    height: '100%',
  },
  cardHeader: {
    '&:after': {
      background: colors.white,
      zIndex: -1,
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 16,
    },
  },
  showArrowOnHover: {
    cursor: 'pointer',
    '&:hover': {
      '& $arrow': {
        opacity: 1,
        marginLeft: 0,
        transition: 'all .3s ease-out',
      },
    },
  },
  footer: {
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center',
    gap: '8px',
    margin: 'auto auto 0 auto',
    cursor: 'pointer',
    color: colors.darkestBlue,
    fontWeight: 'bold',
    flexWrap: 'wrap',
    zIndex: 3,
  },

  cancel: {
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '18px',
    letterSpacing: '0.25px',
    color: '#9D9FA1',
    textAlign: 'center',
    marginTop: 18,
    marginLeft: '-16px',
    '&:hover': {
      textDecoration: 'underline',
    },
    zIndex: 3,
  },
}));

export default useStyles;
